import * as ActionTypes from "../actions/ActionTypes";

const initialState = {
	favourites: [{}],
	tourismEvents: [],
	informativeTexts: [],
	usuariosMenuOpen: true,
	sideMenuOpen: false,
	formMenuOpen: false,
	textMenuOpen: false,
	modifyFormMenuOpen: false,
	questionsMenuOpen: false,
	topquestionsMenuOpen: false,
	analyticsMenuOpen:false,
	listMenuOpen: false,
	updateListMenu: false,
	uploadingImage: false,
	imageUrlResponse: "",
	deletingElement: false,
	creatingEvent: false,
	modifyingElement: false,
	modifyingInformativeText: false,
	eventToModify: {
		id: 0,
		type: "",
		titulo: "",
		info: "",
		link: "",
		imageUrl: ""
	},
	event: {
		imageUrl: ""
	},
	textToModify: {
		id: 0,
		type: "",
		title: "",
		info: ""
	},
	levels:[],
	levelCategories:[]
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case ActionTypes.LOAD_FAVOURITES:
			return {
				...state,
				favourites: action.favourites
			};
		case ActionTypes.LOAD_ACTIVITIES:
			return {
				...state,
				activities: action.activities
			};
		case ActionTypes.LOAD_QUESTIONS:
			return {
				...state,
				questions: action.questions
			};
		case ActionTypes.LOAD_TOPQUESTIONS:
			return {
				...state,
				topquestions: action.questions
			};
		case ActionTypes.LOAD_LEVELS:
			return {
				...state,
				levels: action.levels
			};
		case ActionTypes.LOAD_LEVELCATEGORIES:
			return {
				...state,
				levelCategories: action.levelCategories
			};
		case ActionTypes.LOAD_PROMOTIONS:
			return {
				...state,
				promotions: action.promotions
			};
		case ActionTypes.LOAD_PRINCIPAL:
			return {
				...state,
				principal: action.principal
			};

		case ActionTypes.LOAD_USERS:
			return {
				...state,
				users: action.users
			};

		case ActionTypes.LOAD_ANALYTICS:
			return {
				...state,
				analytics: action.analytics
			};

		case ActionTypes.OPENCLOSE_SIDEMENU:
			return {
				...state,
				sideMenuOpen: !state.sideMenuOpen
			};
		case ActionTypes.OPEN_FORMMENU:
			return {
				...state,
				sideMenuOpen: false,
				listMenuOpen: false,
				textMenuOpen: false,
				formMenuOpen: true,
				principalMenuOpen: false,
				favouritesMenuOpen: false,
				analyticsMenuOpen:false,
			};

		case ActionTypes.OPEN_USUARIOS:
			return {
				...state,
				sideMenuOpen: false,
				usuariosMenuOpen: true,
				questionsMenuOpen: false,
				topquestionsMenuOpen: false,
				analyticsMenuOpen:false,
			};



		case ActionTypes.OPEN_QUESTIONS:
			return {
				...state,
				sideMenuOpen: false,
				usuariosMenuOpen: false,
				questionsMenuOpen: true,
				topquestionsMenuOpen: false,
				analyticsMenuOpen:false,

			};
		case ActionTypes.OPEN_TOPQUESTIONS:
				return {
					...state,
					sideMenuOpen: false,
					usuariosMenuOpen: false,
					topquestionsMenuOpen: true,
					questionsMenuOpen: false,
					analyticsMenuOpen:false,
				};
		case ActionTypes.OPEN_ANALYTICS:
					return {
						...state,
						sideMenuOpen: false,
						usuariosMenuOpen: false,
						questionsMenuOpen: false,
						topquestionsMenuOpen: false,
						analyticsMenuOpen:true,
					};

		case ActionTypes.UPLOADING_IMAGE:
			return {
				...state,
				uploadingImage: true,
				event: {
					...state.event,
					imageUrl: action.imageUrl
				}
			};
		default:
			return state;
	}
};

export default reducer;
